import type { SVGProps } from 'react';

const SvgChevronSmallIsolatedS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 15.02c-.26 0-.51-.1-.71-.29l-4-4A.996.996 0 1 1 8.7 9.32l3.29 3.29 3.29-3.29a.996.996 0 1 1 1.41 1.41l-4 4c-.2.2-.45.29-.71.29z"
    />
  </svg>
);
export default SvgChevronSmallIsolatedS;
